import React from "react";
import HeroCarousel from "../components/HeroCarousel";
import WhatWeDesign from "../components/WhatWeDesign";
import HowItWorks from "../components/HowItWorks";
import WhyLRS from "../components/WhyLRS";
import { HomepageFAQ } from "../components/HomepageFAQ";
import EnquiryForm from "../components/EnquiryForm";
import { usePageMeta } from "../components/Layout";
import { HOMEPAGE_FAQS } from "../lib/faqData";

export default function Home() {
    usePageMeta({
        title: "London Renovation Specialists | Free Home Renovation Design",
        description: "Planning an extension, loft conversion or home reconfiguration in London? Explore our free design service, subject to project feasibility.",
    });
    return (
        <div data-testid="home-page">
            <HeroCarousel />
            <WhatWeDesign />
            <HowItWorks />
            <WhyLRS />
            <HomepageFAQ items={HOMEPAGE_FAQS} />
            <EnquiryForm />
        </div>
    );
}
